import useApi from 'assets/hooks/api/useApi';
import usePageRouter from 'assets/hooks/pageRouter/usePageRouter';
import { useAuthStore } from 'assets/providers/authStore/Provider.AuthStore';
import { useDataProviderPartition } from 'assets/providers/data/DataProvider';
import { documentTranslationListApi } from 'models/localization/documentTranslation/Model.DocumentTranslation';
import ProductRefundDocument from 'models/productManagement/productRefundDocument/Model.ProductRefundDocument';
import { productRefundDocumentIndexRoute } from './ProductRefundDocument.Index';

export default function useProductRefundDocument() {
  const { permissions } = useAuthStore();
  const pageRouter = usePageRouter<
    Module.ProductManagement.ProductRefundDocument.Params,
    Module.ProductManagement.ProductRefundDocument.Query
  >({
    route: productRefundDocumentIndexRoute,
  });
  const productRefundDocumentId = pageRouter.params.id ? parseInt(pageRouter.params.id) : null;

  const { payload: productRefundDocument, isExecuting: isLoadingProductRefundDocument } = useApi(
    {
      action: ProductRefundDocument.find,
      body: { documentId: productRefundDocumentId },
      default: null,
      wait: !productRefundDocumentId,
    },
    [productRefundDocumentId]
  );

  const listDocumentTranslationsApi = useApi(
    {
      action: documentTranslationListApi,
      body: { documentType: 'ProductRefundDocument', documentId: [productRefundDocumentId] },
      wait: !productRefundDocumentId,
    },
    [productRefundDocumentId]
  );
  function reloadTranslatedDocs() {
    listDocumentTranslationsApi.execute((b) => b);
  }

  const canView = permissions.EDIT_PRODUCT;

  return {
    canView,
    pageRouter,
    productRefundDocument,
    isLoadingProductRefundDocument,
    permissions,
    translatedDocumentList: listDocumentTranslationsApi?.payload?.data ?? [],
    reloadTranslatedDocs,
  };
}

export function useProductRefundDocumentProvider() {
  return useDataProviderPartition<ReturnType<typeof useProductRefundDocument>>('ProductRefundDocumentHook');
}
